import {ContainerClusterEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseContainerClusterSelectProps = Omit<
  BaseEntitySelectProps<ContainerClusterEntity>,
  'nameMapper'
>

export const BaseContainerClusterSelect = (props: BaseContainerClusterSelectProps) => {
  const {...rest} = props;

  const nameMapper = useCallback((e: ContainerClusterEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...rest} />;
};
